import { validator } from "LIB/validate-this";
import {
  NO_QUOTE,
  AWAITING_REPLY,
  MAKE_OFFER,
  STANDARD,
  EXCHANGE_ONLY
} from "MODULES/IncomingQuotes/constants";
import * as rules from "LIB/validation/rules";
import { COST, QUANTITY } from "APP_ROOT/constants";
import { CONDITION, LEAD_TIME } from "MODULES/inventories/constants";
import { EXCHANGE_FEE, QUOTE_TYPE } from "MODULES/OutgoingQuotes/constants";

export function validateLineItem(lineItem, values, fieldPrefix = null) {
  const quoteType = fieldPrefix
    ? values[fieldPrefix] && values[fieldPrefix].quote_type
    : values.quote_type;

  if (quoteType !== NO_QUOTE) {
    lineItem.validate(QUANTITY).satisfies(rules.isGreaterThan(0));
    lineItem.validate(CONDITION, QUANTITY).satisfies(rules.required);
  }
  if (![NO_QUOTE, EXCHANGE_ONLY].includes(quoteType)) {
    lineItem.validate(COST).satisfies(rules.isGreaterThanOrEqualTo(0));
  }

  if (quoteType === EXCHANGE_ONLY) {
    lineItem.validate(EXCHANGE_FEE).satisfies(rules.required);
  }

  if ([STANDARD, EXCHANGE_ONLY].includes(quoteType)) {
    lineItem.validate(LEAD_TIME).satisfies(rules.requiredAllowZero);
  }

  if (
    ![NO_QUOTE, AWAITING_REPLY, MAKE_OFFER, EXCHANGE_ONLY].includes(quoteType)
  ) {
    lineItem.validate(COST).satisfies(rules.required, rules.isGreaterThan(0.0));
  }
}

export default function validate(values) {
  return validator(values, form => {
    form.validate("part_id", QUOTE_TYPE).satisfies(rules.required);
    validateLineItem(form, values);
  });
}



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Parts/validate.js